import { Card, SimpleGrid, Text } from "@mantine/core";
import { Fragment, memo } from "react";
import { Link } from "react-router";
import { COLUMN_LABELS, TOOL_LABELS } from "../ToolResultRenderer.constants";
import type { ToolResultDetail } from "../ToolResultRenderer.types";
import { formatCellValue } from "../utils/formatCellValue";
import { resolveLink } from "../utils/resolveLink";

interface DetailCardProps {
  data: ToolResultDetail;
}

function DetailCardComponent({ data }: DetailCardProps) {
  const detailLink = resolveLink(data._link);
  const title = TOOL_LABELS[data.tool_name] ?? data.tool_name;

  return (
    <Card padding="sm" withBorder>
      <Text fw={600} mb="xs" size="sm">
        {detailLink !== null ? <Link to={detailLink}>{title}</Link> : title}
      </Text>
      <SimpleGrid cols={2} spacing="sm" verticalSpacing={4}>
        {Object.entries(data.data).map(([key, value]) => (
          <Fragment key={key}>
            <Text c="dimmed" fw={500} size="sm">
              {COLUMN_LABELS[key] ?? key}
            </Text>
            <Text size="sm">{formatCellValue(value)}</Text>
          </Fragment>
        ))}
      </SimpleGrid>
    </Card>
  );
}

const DetailCard = memo(DetailCardComponent);

export { DetailCard };
